import { VALIDATION_MESSAGES } from "../../utils/Constants";
import { isElementVisibleInViewport, scrollToElement } from "../../utils/UtilFunctions";

const isDateInvalid = (dateString) => dateString?.includes("invalid:");

const getUpdatedOptions = (options, readOnly = false, isDateField = false) => {
  let updatedOptions = { ...options };
  let validateCallback = null;

  if (options?.required?.value && !readOnly && !isDateField) {
    validateCallback = (value) =>
      value?.trim()?.length === 0 ? VALIDATION_MESSAGES.REQUIRED : null;
  }

  if (isDateField && !readOnly) {
    const { maxLength: _maxlength, ...rest } = updatedOptions;
    updatedOptions = {
      ...rest,
    };
    validateCallback = (value) => {
      return dateFieldValidations(value, options?.required?.value, {}) || null;
    };
  }
  if (validateCallback) {
    updatedOptions = {
      ...updatedOptions,
      validate: validateCallback,
    };
  }

  return updatedOptions;
};

const dateFieldValidations = (
  value,
  isRequired = false,
  {
    isBlur = false,
    setError = null,
    clearErrors = null,
    fieldName = "",
    hasPreviousErrors = false,
  }
) => {
  const trimmedValue = value?.trim().replace("invalid:", "") || "";
  let errorMessage = "";

  if (isRequired && trimmedValue?.length === 0)
    errorMessage = VALIDATION_MESSAGES.REQUIRED;

  if (trimmedValue?.length && isDateInvalid(value))
    errorMessage = VALIDATION_MESSAGES.INVALID_DATE;

  if (isBlur && fieldName) {
    if (errorMessage)
      setError(fieldName, { type: "custom", message: errorMessage });
    else if (!errorMessage && !hasPreviousErrors) clearErrors(fieldName);
  } else {
    return errorMessage;
  }
};

const scrollToElementWithFirstFormError = (errors, formRef) => {
  const formElements = [...formRef.current];
  let firstFormErrorElement = null;
  
  formElements.every((element) => {
    if(errors?.[element?.id]) {
      firstFormErrorElement = element;
      return false;
    }
    return true;
  })
  setTimeout(()=>{
     if(firstFormErrorElement) {
    const yOffset = 160; // height of your fixed header (adjust)
    const elementTop = firstFormErrorElement.getBoundingClientRect().top + window.scrollY;
    
    window.scrollTo({
      top: elementTop - yOffset,
      behavior: "smooth"
    });

    firstFormErrorElement.focus({ preventScroll: true });
     } //firstFormErrorElement?.focus({ preventScroll: true });
  },300);
  if (
    firstFormErrorElement &&
    !isElementVisibleInViewport(firstFormErrorElement) &&
    document.activeElement !== firstFormErrorElement
  ) {
    scrollToElement(firstFormErrorElement);
  }
};

const getFormattedInputNumberValue = (value, fractionDigits) => {
  let formattedValue = parseFloat(value);
  if (fractionDigits) {
    formattedValue = formattedValue.toFixed(fractionDigits);
  }
  return formattedValue;
};

const isValueFalsyExceptZero = (value) => {
  return !value && value !== 0;
};

const getCommaSeparatedNumber = (num) => {
  return num?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};
 

const getInputNumberFieldMaxLength = (maxValue) => {
  if(!maxValue) return null;
  return getCommaSeparatedNumber(maxValue).length;
}

const getInputNumberValue = (value) => {
  return isValueFalsyExceptZero(value) ? null : value;
};

const handleNumberDecimalChanges = (
  fieldName,
  currentValue,
  fractionDigits = 0,
  setValue
) => {
  setValue(
    fieldName,
    isValueFalsyExceptZero(currentValue) ? currentValue : getFormattedInputNumberValue(currentValue, fractionDigits),
    {
      shouldValidate: true,
    }
  );
};

const getIntegerPartOfDecimalNumber = (value) => {
  if( !value) return '';

  return value?.split('.')?.[0]?.replaceAll(',', '');
}

function isCursorPositionAfterDecimal(inputField) {
  const inputValue = inputField.value;
  const cursorPosition = inputField.selectionStart;
  const decimalPosition = inputValue.indexOf(".");

  if (decimalPosition === -1) {
    return false; // No decimal point
  }

  return cursorPosition > decimalPosition;
}


export {
  getUpdatedOptions,
  scrollToElementWithFirstFormError,
  getInputNumberFieldMaxLength,
  getInputNumberValue,
  handleNumberDecimalChanges,
  getIntegerPartOfDecimalNumber,
  isCursorPositionAfterDecimal,
  isDateInvalid,
  dateFieldValidations
};
